import { HgSupportedLanguage } from '@smg-real-estate/domus';

import { type Culture } from '@/models/iazi/common/enums';

export const localizeLanguage = (locale: HgSupportedLanguage): string => {
  return locale === HgSupportedLanguage.EN ? locale : `${locale}-CH`;
};

export const getCulture = (locale: HgSupportedLanguage): Culture =>
  locale === HgSupportedLanguage.EN ? `${locale}-US` : `${locale}-CH`;
